import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { LazyHydrate } from '@/atoms/LazyHydrate'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { FaqSection } from '@/organisms/FaqSection'
import { HorizontalShopifyMerchScroller } from '@/organisms/HorizontalShopifyMerchScroller'
import { useShopifyConfig } from '@/organisms/HorizontalShopifyMerchScroller/ShopifyConfigContext'
import { Page } from '@/page'
import { PageDataContext, PageModel } from '@/services/RenderService'

export interface DryBarProjectViewProps {
  pageDataContext: Maybe<PageDataContext>
  page: Maybe<PageModel>
  projectSlug: string
}

export const DryBarProjectView: React.FC<DryBarProjectViewProps> = ({ pageDataContext, page, projectSlug }) => {
  const { storeUrl, accessToken, handle, storeHref } = useShopifyConfig()

  return (
    <main className="overflow-x-hidden bg-core-gray-950 text-white">
      <div className="grid grid-cols-1 gap-14 py-10">
        {!!page && !!pageDataContext && (
          <Page
            page={page}
            pageDataContext={{
              ...pageDataContext,
              contentItemConfig: { padding: true, showThumbnailTitleDescription: true },
            }}
          />
        )}
        <LazyHydrate whenVisible>
          <HorizontalShopifyMerchScroller
            storeUrl={storeUrl as string}
            accessToken={accessToken as string}
            handle={handle as string}
            storeHref={storeHref as string}
            analytics={{
              program: projectSlug,
              context: 'watch-tab',
            }}
            utm={{
              linkContext: 'watch-tab',
              campaign: 'elevated-shopify-carousel',
            }}
            slug={projectSlug}
            padding
          />
        </LazyHydrate>
        <PaddedContainer fluid>
          <FaqSection />
        </PaddedContainer>
      </div>
    </main>
  )
}
